import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Markup } from "interweave";
// Components
import { Input } from "@/common/components";
import { Theme, Typography } from "@mui/material";
import { YoutubeIcon } from "@/common/icons";
// Styles
import { useStyles } from "@/common/lib/style/hooks";
// Libs
import { isNotNull } from "@/common/lib/common";

const styles = (theme: Theme) => ({
  container: {
    width: 900,
    margin: "45px auto",
    padding: "0 25px 15px",
    border: "1px solid " + theme.palette.divider,
    borderTop: "2px solid " + theme.palette.text.primary,
    userSelect: "none",
    "& > div": {
      display: "flex",
      alignItems: "center",
      "& > svg": {
        height: 100,
        fill: "#FF0000",
        marginRight: 10,
      },
      "& > div": {
        width: "100%",
        "& > .MuiTypography-body1": {
          fontSize: "1.5rem",
          fontWeight: "bold",
          color: theme.palette.text.primary,
          userSelect: "none",
          "& > span": {
            fontSize: "1.15rem",
          },
        },
        "& > .MuiTypography-body2": {
          fontSize: "1rem",
          userSelect: "none",
          lineHeight: "1.35",
        },
        "& > .MuiTypography-caption": {
          display: "block",
          color: theme.palette.error.main,
          fontSize: "0.875rem",
          fontWeight: "bold",
          userSelect: "none",
        },
      },
    },
    "& > .MuiTextField-root": {
      width: "100%",
      alignItems: "unset",
      "& > .MuiFormHelperText-root": {
        fontSize: "0.825rem",
      },
    },
    "& > span": {
      fontSize: "0.925rem",
    },
  },
});

interface propType {
  value: VehicleData;
  dispatch: React.Dispatch<React.SetStateAction<VehicleData>>;
}

const YoutubeContainer = ({ value, dispatch }: propType) => {
  const classes = useStyles(styles);
  const { t } = useTranslation();

  const [youtubeHelpText, setYoutubeHelpText] = useState<string | null>("");

  const checkYoutubeLink = (e: any) => {
    if (e.target !== undefined && isNotNull(e.target.value)) {
      const linkRegex =
        /^(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)/;
      if (linkRegex.test(e.target.value)) {
        setYoutubeHelpText("");
      } else {
        setYoutubeHelpText(t("REGISTER.MEDIA.YOUTUBE.INCORRECT_LINK"));
      }
    }
  };

  useEffect(() => {
    setYoutubeHelpText("");
  }, [value.media.youtube]);

  return (
    <div className={classes.container}>
      <div>
        <YoutubeIcon />
        <div>
          <Typography variant="body1">
            <Markup content={t("REGISTER.MEDIA.YOUTUBE.TITLE")} />
          </Typography>
          <Typography variant="body2">
            {t("REGISTER.MEDIA.YOUTUBE.CONTENT_1")}
          </Typography>
          <Typography variant="caption">
            {t("REGISTER.MEDIA.YOUTUBE.CONTENT_2")}
          </Typography>
        </div>
      </div>
      <Input
        variant="standard"
        value={value.media.youtube}
        dispatch={(_value: string) => {
          dispatch({
            ...value,
            media: {
              ...value.media,
              youtube: _value,
            },
          });
        }}
        onBlur={checkYoutubeLink}
        error={youtubeHelpText !== "" ? true : false}
        helperText={youtubeHelpText}
        placeholder={t("REGISTER.MEDIA.YOUTUBE.INPUT_LINK")}
      />
      <span className={classes.example}>
        {"Ex. https://www.youtube.com/watch?v=rI35OKGx5AI"}
      </span>
    </div>
  );
};

export default YoutubeContainer;
